<template>
    <div id="inner-wrapper">
        <router-view></router-view>
    </div>
</template>
<script>
export default {
    name: "APP"
};
</script>



// WEBPACK FOOTER //
// App.vue?ab800a3a